import { render, staticRenderFns } from "./dic_type_edit.vue?vue&type=template&id=a538f828&scoped=true"
import script from "./dic_type_edit.vue?vue&type=script&lang=js"
export * from "./dic_type_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a538f828",
  null
  
)

export default component.exports